import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
// import AlertComponent from "../../../../_metronic/_helpers/AlertComponent";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import PlusIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CircularProgress from "@material-ui/core/CircularProgress/index";
import Avatar from "@material-ui/core/Avatar";
import { deepPurple } from "@material-ui/core/colors";
import Grid from "@material-ui/core/Grid";
import StatusButton from "../../../../_metronic/_helpers/StatusButton";


const headRows = [
  { id: "photo", numeric: false, disablePadding: true, label: "Image" },
  { id: "CampaignCategoryLangs.FirstOrDefault(m=>m.LangId==1).Name", numeric: false, disablePadding: true, label: "Name Az" },

  { id: "status", numeric: false, disablePadding: true, label: "Status" },

  { id: "order", numeric: false, disablePadding: true, label: "Order" },

  { id: "tools", numeric: false, disablePadding: true, label: "Tools" },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "Select all desserts" }}
          />
        </TableCell>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "right" : "left"}
            padding={row.disablePadding ? "none" : "default"}
            sortDirection={orderBy === row.id ? false : false}
          // className="px-4 pb-2 pt-2"

          >
            <TableSortLabel
              active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return row.id !== "tools" ? onRequestSort(row.id) : null;
              }}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.bool.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected, setOpenCreate, onDeleteCategoryNames } = props;

  return (
    <Toolbar
      className={clsx(classes.root, classes.toolbar, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 && (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 && (
          <Tooltip className="mr-2" title="Delete">
            <IconButton aria-label="Delete" onClick={onDeleteCategoryNames}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <Tooltip title="Create" placement="top">
        <button
          className="btn flex-shrink-0  btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle"
          onClick={() => setOpenCreate(true)}
        >
          <PlusIcon />
        </button>
      </Tooltip>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  purpleAvatar: {
    margin: 10,
    marginLeft: 0,
    color: "#fff",
    backgroundColor: deepPurple[500],
  },
  avatar: {
    margin: 10,
    marginLeft: 0,
  },
  toolbar: {
    minHeight: theme.spacing(2),
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#63C059",
  },
}));

export default function EnhancedTable(props) {
  const {
    setSortField,
    setOrderByTable,
    sortField,
    orderBy,
    setOpenEdit,
    setOpenRemove,
    setOpenCreate,
    isLoaded,
    error,
    rows,
    onCategoryNameChoose,
    updateSkip,
    updateTake,
    count,

    setCategoryNameId,
    setDeleteCategoryNamesID,
    deleteCategoryNamesIds,
    onDeleteCategoryNames,
    onUpdateUserStatus
  } = props;
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  function handleRequestSort(property) {
    const isDesc = sortField === property && !orderBy;

    setOrderByTable(isDesc);
    setSortField(property);
    updateTake(10);
    setRowsPerPage(10);
    updateSkip(0);
    setPage(0);
  }

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);

      setDeleteCategoryNamesID(newSelecteds);
      return;
    }

    setDeleteCategoryNamesID([]);
  }

  function handleClick(event, id) {
    const selectedIndex = deleteCategoryNamesIds.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(deleteCategoryNamesIds, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(deleteCategoryNamesIds.slice(1));
    } else if (selectedIndex === deleteCategoryNamesIds.length - 1) {
      newSelected = newSelected.concat(deleteCategoryNamesIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        deleteCategoryNamesIds.slice(0, selectedIndex),
        deleteCategoryNamesIds.slice(selectedIndex + 1)
      );
    }

    setDeleteCategoryNamesID(newSelected);
  }

  function handleChangePage(event, newPage) {
    setPage(newPage);
    updateSkip(newPage * rowsPerPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    updateTake(+event.target.value);
    setPage(0);
    updateSkip(0);
  }

  const isSelected = (id) => deleteCategoryNamesIds.indexOf(id) !== -1;

  return (
    <div className="col-12">
      <div className={classes.root}>
        <Paper className={classes.paper}>
          {isLoaded && !rows.length && (
            <div className={classes.progresRoot}>
              <CircularProgress className={classes.progress} />
            </div>
          )}
          <EnhancedTableToolbar
            numSelected={deleteCategoryNamesIds.length}
            setOpenCreate={setOpenCreate}
            onDeleteCategoryNames={onDeleteCategoryNames}
          />
          <div className={classes.tableWrapper}>
            {rows.length ? (
              <Table className={classes.table} aria-labelledby="tableTitle">
                <EnhancedTableHead
                  numSelected={deleteCategoryNamesIds.length}
                  order={orderBy}
                  orderBy={sortField}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                />
                <TableBody>
                  {rows.map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isItemSelected}
                            inputProps={{ "aria-labelledby": labelId }}
                            onChange={(event) => handleClick(event, row.id)}
                          />
                        </TableCell>

                        <TableCell padding="none" className="pr-4">
                          <Grid>
                            <Avatar

                              src={`${row.photo
                                  ? `https://cdn.deyerlisen.az/${row.photo}`
                                  : "/media/logos/default.png"
                                }`}
                              className={classes.avatar}
                            />
                          </Grid>
                        </TableCell>

                        <TableCell padding="none" className="pr-4">
                          {row.nameAz}
                        </TableCell>

                        <TableCell padding="none" className="pr-4">
                          <StatusButton
                            id={row.id}
                            isActive={row.isActive}
                            onUpdateUserStatus={onUpdateUserStatus}
                          />
                        </TableCell>

                        <TableCell padding="none" className="pr-4">
                          {row.order}
                        </TableCell>

                        <TableCell padding="none" className="pr-4">
                          <Tooltip title="Edit" placement="top">
                            <button
                              aria-label="edit"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-dark btn-hover-dark mr-2"
                              onClick={() => {
                                setOpenEdit(true);
                                onCategoryNameChoose(row.id);
                              }}
                            >
                              <EditIcon />
                            </button>
                          </Tooltip>
                          <Tooltip title="Delete" placement="top">
                            <button
                              aria-label="Delete"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger"
                              onClick={() => {
                                setOpenRemove(true);
                                setCategoryNameId(row.id);
                              }}
                            >
                              <DeleteIcon />
                            </button>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            ) : !rows.length && !isLoaded && !error ? (
              // <AlertComponent variant="info" message="No information found" />
              <div className="noInfo"><img src="./media/error/search2.png" alt="information" />
                <h4>No information found</h4></div>
            ) : (
              !isLoaded &&
              error && (
                // <AlertComponent
                //   variant="danger"
                //   message="We've lost the connection"
                // />
                <div className="noInfo"><img src="./media/error/connection.png" className="info-img" alt="connection" />
                  <h4>We've lost the connection</h4></div>
              )
            )}
          </div>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </div>
  );
}
